import { useState, useEffect, useMemo } from "react";
import { fetchSourceData } from "../services/source-data.service";
import { useDispatch, useSelector } from "react-redux";
import { setSourceUrl } from "context/features/dataSlice";

export function useSourceData() {
  const dispatch = useDispatch();

  const [sourceData, setSourceData] = useState();
  const [sourceNotFound, setSourceNotFound] = useState(false);

  const { sourceUrl } = useSelector((state) => state.data);

  const isSourceSidebarOpen = useMemo(() => sourceUrl != null, [sourceUrl]);

  const isLoading = useMemo(() => sourceData == null && !sourceNotFound, [sourceData, sourceNotFound]);

  function handleCloseSourceSidebar() {
    dispatch(setSourceUrl(null));
    setSourceData(null);
    setSourceNotFound(false);
  }

  async function getSourceData(sourceUrl) {
    // setIsLoading(true);
    try {
      const data = await fetchSourceData(sourceUrl);
      const json = data.data;
      if (json == null) {
        setSourceNotFound(true);
      } else {
        setSourceData(json);
      }
    } catch (error) {
      console.error("Failed to Publisher Data", error);
      // } finally {
      //   setIsLoading(false);
    }
  }

  useEffect(() => {
    if (sourceUrl == null) {
      setSourceData(null);
      setSourceNotFound(false);
    } else {
      getSourceData(sourceUrl);
    }
  }, [sourceUrl]);

  return {
    handleCloseSourceSidebar,
    isLoading,
    isSourceSidebarOpen,
    sourceData,
    sourceNotFound,
    sourceUrl,
  };
}
